// Full-document render of the toppers UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility-page layout.
//
// right_bar is serialized per-block server-side (it can't be Pick'd -- its
// inline StreamField stream_block has no get_json_schema) and reproduces the
// `{% include_block %}` per-child `w-block-{type} block-{type}` wrapper (the
// RightBarSection SCSS depends on `.block-right_bar_section`).
import React from "react";

import { templates } from "@reactivated";

import { RightBarSection } from "../blocks/RightBarSection";
import { ContentTitle } from "../components/ContentTitle";
import { PageSkeleton } from "../components/PageSkeleton";
import { UtilityPageBody } from "../components/UtilityPageBody";
import { UtilitySideNav } from "../components/UtilitySideNav";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader / SiteFooter chain via PageSkeleton, which is typed with
// mutable reactivated props. The body StreamField + RightBarSection accept both.
type IProps = templates.UtilityPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const { page, nav_items, has_right_bar, right_bar_items } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {nav_items.length > 0 && (
                    <div className="l-side-nav">
                        <UtilitySideNav items={nav_items} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <ContentTitle
                        title={page.title}
                        phoneHref={props.content_title_phone_href}
                        phoneDisplay={props.content_title_phone_display}
                    />

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        {page.body ? (
                            <UtilityPageBody value={page.body.value} />
                        ) : null}
                        {/* {% block extra_body %} is empty for UtilityPage
                            (only the form/contact pages override it -- those
                            still render via the Django chain). */}
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar_items.map((item, i) =>
                                item.block_type === "right_bar_section" &&
                                item.section ? (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                    >
                                        <RightBarSection value={item.section} />
                                    </div>
                                ) : (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                        dangerouslySetInnerHTML={{
                                            __html: item.html,
                                        }}
                                    />
                                ),
                            )}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
